module.exports = __webpack_public_path__ + "static/media/shopify-scripts.098c05b3.svg";